import React from 'react';
import { GelFlexContainer } from '@tal-gel/core';
import { GelRowLayout, GelTooltip } from '@tal-gel/components';
import { overviewRowLayout, overviewFlexContainer, boldLabel, boldLabelWithFlex} from '../Shared/Styles';
import { formatDateTime } from '../Shared/Text';
import { get, has } from 'lodash';
import policySourceSystem from '../Shared/policySourceSystem';

export default function Overview(props) {
  var phoneNumber = get(props.policyDetails, 'policy.policyOwner.contactDetails.telephone', '');

  if (phoneNumber!== undefined && phoneNumber !== null && phoneNumber.length > 8) {
    phoneNumber = phoneNumber.slice(0, 4) + " " + phoneNumber.slice(4, 7) + " " + phoneNumber.slice(7);
  }

  var sourceSystemName = policySourceSystem(props.policies); 

  return (
    <GelRowLayout gutter="none" style={overviewRowLayout}>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div data-testid="overviewLoading" style={boldLabelWithFlex}>Policy Origin <GelTooltip right>
        PPlans previously branded BT Life
        </GelTooltip></div>
        <div data-testid="sourceSystemName">{sourceSystemName}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Policy Status</div>
        <div data-testid="policyStatus">{get(props.policyDetails, 'policy.status', '')}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Policy Owner Name</div>
        <div data-testid="policyOwnerOverview">{get(props.policyDetails, 'policy.policyOwner.owner', '')}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Policy Commencement Date</div>
        <div data-testid="policyCommencementDate">{has(props.policyDetails, 'policy.commencementDate') ?
          (formatDateTime(props.policyDetails.policy.commencementDate)) : ""}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Payment Frequency</div>
        <div data-testid="paymentFrequency">{get(props.policyDetails, 'payment.paymentFrequency', '')}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabelWithFlex}>Instalment Premium <GelTooltip right>
        The Instalment Premium amount is inclusive of any applicable Stamp duty & Policy fee
      </GelTooltip></div>
        <div data-testid="instalmentPremium">{has(props.policyDetails, 'payment.installmentPremium') ? '$' + props.policyDetails.payment.installmentPremium.toLocaleString("en-AU", { minimumFractionDigits: 2 }) : ""}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabelWithFlex}>Annual Premium <GelTooltip right>
        The Annual Premium amount is inclusive of any applicable Stamp duty & Policy fee
        </GelTooltip></div>                
        <div data-testid="annualPremium">{has(props.policyDetails, 'payment.annualPremium') ? '$' + props.policyDetails.payment.annualPremium.toLocaleString("en-AU", { minimumFractionDigits: 2 }) : ""}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Policy Fee</div>
        <div data-testid="policyFee">{has(props.policyDetails, 'payment.policyFee') ? '$' + props.policyDetails.payment.policyFee.toLocaleString("en-AU", { minimumFractionDigits: 2 }) : ""}</div>
      </GelFlexContainer>      

      {sourceSystemName == "PPlans" &&
      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Stamp Duty</div>
        <div data-testid="stampDuty">{has(props.policies, '[0].annualStampDuty') && props.policies !== null ? 
        '$' + props.policies[0].annualStampDuty.toLocaleString("en-AU", { minimumFractionDigits: 2 }) : ""}</div>
      </GelFlexContainer>
      }

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Next Bill Date</div>
        <div data-testid="nextBillDate">{has(props.policyDetails, 'payment.nextBillDate') && props.policyDetails.payment.nextBillDate !== null ?
          (formatDateTime(props.policyDetails.payment.nextBillDate)) : ""}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Paid To Date</div>
        <div data-testid="paidToDate">{has(props.policyDetails, 'payment.paidToDate')  && props.policyDetails.payment.paidToDate !== null ?
          (formatDateTime(props.policyDetails.payment.paidToDate)) : ""}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Policy Owner Address</div>
        <div data-testid="address">{get(props.policyDetails, 'policy.policyOwner.contactDetails.address', '')}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Policy Owner Telephone</div>
        <div data-testid="phoneNumber">{phoneNumber}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Adviser Name</div>
        <div data-testid="adviserName">{get(props.policyDetails, 'adviser.adviserName', '')}</div>
      </GelFlexContainer>

      <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <div style={boldLabel}>Adviser Number</div>
        <div data-testid="adviserNumber">{get(props.policyDetails, 'adviser.adviserNumber', '')}</div>
      </GelFlexContainer>

      {/* <GelFlexContainer justifyContent="space-between" style={overviewFlexContainer}>
        <a href={`/dashboard/pds-documents-asteron`} target="_blank" rel="noreferrer" style={tableBodyDownloadLink}><i className="fa fa-download download-icon" style={tableBodyDownloadLinkIcon}></i><span> Download Product Disclosure Statement</span></a>
      </GelFlexContainer> */}
    </GelRowLayout>

  );
}
